import { RowTypesSettingsController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Settings editor for Row types (Palkkalajit)
 * @example
 * ```html
 * <salaxy-row-types-sessings></salaxy-row-types-sessings>
 * ```
 */
export class RowTypesSettings extends ComponentBase {
  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {
    /**
     * Defines the type of rows editor: "builtIn" for built-in rows,
     * "custom" for custom rows, "prices" company specific default prices per row type.
     */
    mode: "@",

    /**
     * Set this property if you want to explicitly set the model.
     * If undefinded, the component binds to company settings.
     */
    model: "<",
  };

  /** Uses the AccountController */
  public controller = RowTypesSettingsController;

  /** Default template is the view  */
  public defaultTemplate = "salaxy-components/settings/RowTypesSettings.html";

}
